import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
const ProductTrainingDetails = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoader] = useState(false);
  const [index, setIndex] = useState(0);

  const value = useSelector((state) => state.viewDetails);

  useEffect(() => {
    const result = props.data.map((item) => {
      return {
        ...item,
        ProductTrainingdate: item.ProductTrainingDate
          ? moment(new Date(item.ProductTrainingDate)).format("YYYY-MM-DD")
          : "",
      };
    });

    setData(result);
  }, [props]);

  useEffect(() => {
    setIndex(value.index);
  }, [value]);

  return (
    <>
      {data.length > 0 ? (
        <div>
          <Grid className="p-10px" container spacing={2}>
            <Grid item xs={12} container>
              <Grid item xs={3}>
                Product Training Status :
              </Grid>
              <Grid item xs={9}>
                {data[index].ProductTrainingStatus}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                Attended Product Training :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].AttendedProductTraining != null
                  ? data[index].AttendedProductTraining === true
                    ? "Yes"
                    : "No"
                  : null}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                Product Training Date and Time :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].ProductTrainingdate}{" "}
                {data[index].ProductTrainingTime}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                Product Training Zoom Link and Password :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].ProductTrainingZoomLink}{" "}
                {data[index].ProductTrainingZoomPassword}
              </Grid>
            </Grid>
          </Grid>
        </div>
      ) : null}
    </>
  );
};

export default ProductTrainingDetails;
